import React, { useEffect, useState } from 'react';
import ModalComponent from '../../components/ModalComponent';
import '../../assets/style/Modal.css';
import ModalHeader from '../../components/ModalHeader';
import {
  CLICK_ACTIONS,
  DEFAULT_OPTION_TRACK_COMPLAINT,
} from '../../utils/Constant';
import CenterSpinner from '../../components/CenterSpinner';
import {
  SelectOptionType,
  TrackComplaintsDetailedType,
  EmployeeNameType,
} from '../../utils/Types';
import { Button, Label } from 'reactstrap';
import {
  checkNullValue,
  formattedDateWithFormat,
  getBlankValueIfNUll,
  getNoteDate,
} from '../../utils/Util';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import MAutoCompleteWithId from '../../components/MAutoCompleteWithId';
import PreviewAttachmentModal from './PreviewAttachmentModal';
import { useAppDispatch, useAppSelector } from '../../store/redux-hooks';
import {
  getEmployeeList,
  trackComplaintsSelector,
} from '../../features/trackComplaintsSlice';
import classNames from 'classnames';
import {
  assignEmployee,
  getComplaintDetails,
  severityIds,
  statusIds,
  updateEmployee,
} from '../compliant/TrackCompliantHelper';
import { getEmployeeNameListWithUniqueId } from '../task-assigned/TaskAssignHelper';
import { useLoader } from '../../loader/LoaderProvider';

interface ITrackCompliantModalProps {
  isOpen: boolean;
  complaintId?: string | number | null;
  toggleModal: (action: string) => void;
}

const TrackCompliantModal: React.FunctionComponent<
  ITrackCompliantModalProps
> = ({ isOpen, complaintId, toggleModal }: ITrackCompliantModalProps) => {
  const { showLoader, setShowLoader } = useLoader();
  const [isAttachmentModelOpen, setIsAttachmentModelOpen] =
    useState<boolean>(false);
  const [employeeOption, setEmployeeOption] = useState<SelectOptionType[]>([]);
  const [employee, setEmployee] = useState<SelectOptionType>(
    DEFAULT_OPTION_TRACK_COMPLAINT
  );
  const trackCompliantDetails: TrackComplaintsDetailedType = useAppSelector(
    trackComplaintsSelector
  ).detailedComplaintData.result;
  const employeeList: EmployeeNameType[] = useAppSelector(
    trackComplaintsSelector
  ).employeeList;
  const dispatch = useAppDispatch();

  useEffect(() => {
    isOpen && getComplaintDetails(dispatch, setShowLoader, complaintId);
  }, [complaintId]);

  useEffect(() => {
    if (trackCompliantDetails.zone && trackCompliantDetails.state) {
      dispatch(getEmployeeList());
    }
  }, [trackCompliantDetails.zone, trackCompliantDetails.state]);

  useEffect(() => {
    updateEmployee(trackCompliantDetails, setEmployee);
  }, [trackCompliantDetails]);

  useEffect(() => {
    if (employee?.value)
      assignEmployee(
        trackCompliantDetails,
        employeeList,
        employee,
        dispatch,
        setShowLoader,
        complaintId
      );
  }, [employee]);

  useEffect(() => {
    setEmployeeOption(getEmployeeNameListWithUniqueId(employeeList));
  }, [employeeList]);

  const onAction = () => {
    toggleModal(CLICK_ACTIONS.NO_ACTION);
  };
  const getCompliantDetails = () => (
    <div className="mt-1 mb-0 pb-0 mx-4">
      <Row>
        <Col xs={6} md={3}>
          <Label className="mb-0 model-label-name">Complaint Id</Label>
          <br />
          <Label className="mb-0 model-label-value">
            {checkNullValue(trackCompliantDetails.complaintUniqueId)}
          </Label>
        </Col>
      </Row>
      <Row>
        <Col xs={6} md={6}>
          <Label className="mb-0 model-label-name">Issue Subject</Label>
          <br />
          <Label className="mb-0 model-label-value">
            {checkNullValue(trackCompliantDetails.issueSubject)}
          </Label>
        </Col>
        <Col xs={6} md={6}>
          <Label className="mb-0 model-label-name">Severity</Label>
          <br />
          <Label
            className={classNames('mb-0 model-label-value ', {
              'text-danger':
                trackCompliantDetails.severityId == severityIds.high ||
                trackCompliantDetails.severityId == severityIds.veryHigh,
              'text-warning':
                trackCompliantDetails.severityId == severityIds.medium,
              'text-primary':
                trackCompliantDetails.severityId == severityIds.low,
            })}
          >
            {checkNullValue(trackCompliantDetails.severityName)}
          </Label>
        </Col>
      </Row>
      <Row>
        <Col xs={6} md={6}>
          <Label className="mb-0 model-label-name">Issue Description</Label>
          <br />
          <Label className="mb-0 model-label-value">
            {checkNullValue(trackCompliantDetails.issueDescription)}
          </Label>
        </Col>
        <Col xs={6} md={3}>
          <Label className="mb-0 model-label-name">Issue Category</Label>
          <br />
          <Label className="mb-0 model-label-value">
            {checkNullValue(trackCompliantDetails.category)}
          </Label>
        </Col>
        <Col xs={6} md={3}>
          <Label className="mb-0 model-label-name">ETA</Label>
          <br />
          <Label className="mb-0 model-label-value">
            {formattedDateWithFormat(
              trackCompliantDetails.complaintEta,
              'DD-MM-YYYY hh:mm A'
            )}
          </Label>
        </Col>
      </Row>

      <hr />
    </div>
  );
  const getBasicsDetails = () => (
    <div className="mt-0 mb-0 pb-0 mx-4">
      <div className="toolBar-name">Customer Details</div>
      <Row>
        <Col xs={6} md={3}>
          <Label className="mb-0 model-label-name">Employee Name</Label>
          <br />
          <Label className="mb-0 model-label-value">
            {getBlankValueIfNUll(trackCompliantDetails.customerName)}
          </Label>
        </Col>
        <Col xs={6} md={3}>
          <Label className="mb-0 model-label-name">Contact</Label>
          <br />
          <Label className="mb-0 model-label-value">
            {checkNullValue(trackCompliantDetails?.customerNumber)}
          </Label>
        </Col>
        <Col xs={6} md={3}>
          <Label className="mb-0 model-label-name">Email Id</Label>
          <br />
          <Label className="mb-0 model-label-value">
            {checkNullValue(trackCompliantDetails.customerEmail)}
          </Label>
        </Col>
        <Col xs={6} md={3}></Col>
      </Row>
      <Row className="mt-4">
        <Col xs={6} md={2}>
          <Label className="mb-0 model-label-name">Zone</Label>
          <br />
          <Label className="mb-0 model-label-value">
            {checkNullValue(trackCompliantDetails.zoneName)}
          </Label>
        </Col>
        <Col xs={6} md={2}>
          <Label className="mb-0 model-label-name">State</Label>
          <br />
          <Label className="mb-0 model-label-value">
            {checkNullValue(trackCompliantDetails?.stateName)}
          </Label>
        </Col>
        <Col xs={6} md={3}>
          <Label className="mb-0 model-label-name">District</Label>
          <br />
          <Label className="mb-0 model-label-value">
            {checkNullValue(trackCompliantDetails?.districtName)}
          </Label>
        </Col>
        <Col xs={6} md={3}>
          <Label className="mb-0 model-label-name">City / Village</Label>
          <br />
          <Label className="mb-0 model-label-value">
            {checkNullValue(trackCompliantDetails?.cityName)}
          </Label>
        </Col>
        <Col xs={6} md={2}>
          <Label className="mb-0 model-label-name">Pincode</Label>
          <br />
          <Label className="mb-0 model-label-value">
            {checkNullValue(trackCompliantDetails?.pincode)}
          </Label>
        </Col>
      </Row>
      <hr />
    </div>
  );

  const getAttendanceDetails = () => (
    <div className="mx-4">
      <div className="toolBar-name">Employee Details</div>
      <Row>
        <Col xs={6} md={6}>
          <Label className="mb-0 model-label-name">Name</Label>
          <br />
          <MAutoCompleteWithId
            label={''}
            options={employeeOption}
            onChange={(newValue) => setEmployee(newValue)}
            value={employee}
            disabled={
              trackCompliantDetails.complaintStatus != statusIds.inProgress
            }
            highLightSelectedOption={true}
          />
        </Col>
      </Row>

      <Row className="mt-3">
        <Col xs={6} md={3}>
          <Label className="mb-0 model-label-name">Employee Id</Label>
          <br />
          <Label className="mb-0 model-label-value">
            {checkNullValue(
              trackCompliantDetails?.taskDetails?.assignedToEmployeeUniqueId
            )}
          </Label>
        </Col>
        <Col xs={6} md={3}>
          <Label className="mb-0 model-label-name">Role</Label>
          <br />
          <Label className="mb-0 model-label-value">
            {checkNullValue(
              trackCompliantDetails?.taskDetails?.assignedToRoleName
            )}
          </Label>
        </Col>
        <Col xs={6} md={3}>
          <Label className="mb-0 model-label-name">Contact</Label>
          <br />
          <Label className="mb-0 model-label-value">
            {checkNullValue(
              trackCompliantDetails?.taskDetails?.assignedToNumber
            )}
          </Label>
        </Col>
      </Row>

      <div className="bg-comment rounded border px-3 pt-2 pb-2 mt-3">
        <Label for="comment" className="model-comment-title">
          Log Details
        </Label>
        <div className="activity-log-compliant">
          <ul className="li-item model-log-value">
            {trackCompliantDetails?.notes?.length
              ? trackCompliantDetails?.notes.map((noteItem) => (
                  <li
                    className="mt-1"
                    key={noteItem?.notesId ?? noteItem?.notesid}
                  >
                    {getNoteDate(noteItem)}
                    {noteItem.notesDescription}
                  </li>
                ))
              : '-'}
          </ul>
        </div>
      </div>
      <div className="d-flex justify-content-center mt-5 mb-2">
        <Button
          variant="primary"
          className="m-1 cl-btn-outline-primary-fill"
          onClick={() => {
            setIsAttachmentModelOpen(!isAttachmentModelOpen);
          }}
          disabled={!trackCompliantDetails?.media?.length}
        >
          View Attachment
        </Button>
        <Button
          variant="outline-primary"
          className="m-1 cl-btn-primary"
          onClick={() => {
            onAction();
          }}
        >
          Close
        </Button>
      </div>
    </div>
  );

  return (
    <ModalComponent
      isOpen={isOpen}
      toggle={() => {
        toggleModal(CLICK_ACTIONS.NO_ACTION);
      }}
      className="modalWrapper"
      backdrop="static"
    >
      <>
        <div className="d-flex justify-content-center">
          <div className="bg-white p-2 modal-90 rounded border">
            <ModalHeader
              closeOnly={true}
              toggle={() => {
                toggleModal(CLICK_ACTIONS.NO_ACTION);
              }}
            />
            {getCompliantDetails()}
            {getBasicsDetails()}
            {getAttendanceDetails()}
            <CenterSpinner showLoader={showLoader} />
          </div>
        </div>
        <PreviewAttachmentModal
          isOpen={isAttachmentModelOpen}
          toggleModal={() => {
            setIsAttachmentModelOpen(!isAttachmentModelOpen);
          }}
          documents={trackCompliantDetails.media}
        />
      </>
    </ModalComponent>
  );
};

export default TrackCompliantModal;
